import HeroImage from "@/assets/images/about-hero.jpg";

export default function HeroSection() {
  return (
    <section className="relative h-96 flex items-center">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${HeroImage}')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#212026]/80 via-[#212026]/60 to-[#212026]/40"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
        <div className="space-y-6">
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight">
            About Us
          </h1>
          <p className="text-xl md:text-2xl text-[#dbcfbf] max-w-3xl mx-auto">
            Your trusted partner in precision design and engineering solutions
          </p>
        </div>
      </div>
    </section>
  );
}
